export const DEFAULT_PROGRESS_AMOUNT = 0;

export default {
  DEFAULT_PROGRESS_AMOUNT,
};
